import { ToneCardComponent } from './tonecard/tonecardcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIDataModel } from '../../../../toolkit/uicomponent';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { FeaturedCategoryToneCardViewImpl } from './tonecardview';


export class FeaturedCategoryToneCardComponent extends ToneCardComponent
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FeaturedCategoryToneCardViewImpl(applicationContext, uiComponentHandler);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecardcomponent.tsx